import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useAppDispatch } from '@/shared/model';
import { addOrganizationIntegration } from '../../../model/actions';
import { REDDIT_REPORTING_INTEGRATION_ID } from '../../../model/constants';
import { BROADCAST_CHANNEL_NAME } from './constants';

interface UseRedditCodeState {
  processing: boolean;
  openDataAccessDialog: () => void;
}

export const useRedditCode = (): UseRedditCodeState => {
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [processing, setProcessing] = useState(false);

  return {
    processing,
    openDataAccessDialog: () => {
      const clientId = import.meta.env.VITE_REDDIT_REPORTING_CILENT_ID;
      const redirectURI = 'https://app.campaignswell.com/datasources/reddit';
      const state = crypto.randomUUID();
      const url = `https://www.reddit.com/api/v1/authorize?client_id=${clientId}&response_type=code&state=${state}&redirect_uri=${redirectURI}&duration=permanent&scope=adsread,identity`;
      const broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
      const dataAccessWindow = window.open(url, '_blank');
      const messageHandler = (
        event: MessageEvent<{ code: string; state: string }>,
      ) => {
        const { code, state: eventState } = event.data;

        if (eventState !== state) {
          return;
        }

        dataAccessWindow?.close();
        broadcastChannel.removeEventListener('message', messageHandler);

        setProcessing(true);
        dispatch(
          addOrganizationIntegration({
            sourceIntegrationId: REDDIT_REPORTING_INTEGRATION_ID,
            configuration: {
              clientId,
              code,
              redirectURI,
            },
          }),
        )
          .catch(() => {
            enqueueSnackbar('Unable to add account. Please, try again.', {
              variant: 'error',
              autoHideDuration: 4000,
            });
          })
          .finally(() => {
            setProcessing(false);
          });
      };

      broadcastChannel.addEventListener('message', messageHandler);
    },
  };
};
